import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationService } from '../../../../../common/services';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { ShipmentWaybillMaterialsService } from './shipment-waybill-materials.service';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { ShipmentWaybillMaterialModel } from '../../models/shipment-waybill-materials.model';
import {
  ShipmentWaybillMaterialsInitialState,
  ShipmentWaybillMaterialsLoad,
} from './shipment-waybill-materials.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type ShipmentWaybillMaterialsStateModel = ListServerPaginationStateModel<ShipmentWaybillMaterialModel>;

const initialState: ShipmentWaybillMaterialsStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<ShipmentWaybillMaterialsStateModel>({
  name: 'shipmentWaybillMaterials',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillMaterialsState {
  constructor(
    private shipmentWaybillMaterialsService: ShipmentWaybillMaterialsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: ShipmentWaybillMaterialsStateModel): ShipmentWaybillMaterialsStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentWaybillMaterialsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getMaterials(state: ShipmentWaybillMaterialsStateModel): ShipmentWaybillMaterialModel[] {
    return state.items;
  }

  @Action(ShipmentWaybillMaterialsLoad)
  getWaybillMaterials(
    ctx: StateContext<ShipmentWaybillMaterialsStateModel>,
    { payload }: ShipmentWaybillMaterialsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillMaterialsService.getShipmentWaybillMaterials(payload).pipe(
      map((state: ShipmentWaybillMaterialsStateModel) => {
        ctx.patchState({ ...state, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillMaterialsInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillMaterialsStateModel>): void {
    ctx.setState(initialState);
  }
}
